import * as yup from 'yup';
import dayjs from 'dayjs';
import { API as products } from '../../../products/api';

export const ServiceConf = {
  schema: {
    service_date: yup
      .date()
      .nullable()
      .required('Date is required or invalid')
      .transform((value, originalValue) => {
        const parsedDate = dayjs(originalValue, 'YYYY-MM-DD', true);
        return parsedDate?.isValid() ? parsedDate.toDate() : null;
      }),
    operation_service: yup.string().nullable().required('Service detail is required'),
    id_item: yup.object().nullable(),
  },
  defaultValues: {
    service_date: dayjs(),
    operation_service: '',
    id_item: null,
  },
  fields: [
    {
      id: 'operation_service',
      name: 'operation_service',
      type: 'text',
      label: 'Service details',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'service_date',
      name: 'service_date',
      type: 'date',
      label: 'Date',
      required: true,
      xs: 12,
      sm: 6,
    },
    {
      id: 'id_item',
      name: 'id_item',
      type: 'async_autocomplete',
      label: 'Article',
      api: products.selectAG,
      required: false,
      xs: 12,
      sm: 6,
      autoFocus: true,
    },
  ],
};
